"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fs = exports.firebase = void 0;
const app_1 = __importDefault(require("firebase/app"));
exports.firebase = app_1.default;
// In theory this should not be needed, as setup will be taken care of by the application using this library
require("firebase/firestore");
const fs = app_1.default.firestore;
exports.fs = fs;
//# sourceMappingURL=firebase.js.map